import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { AppStateType } from '../../reducers'
import { selectGroup } from '../../selectors/group'
import { selectActiveModal } from '../../selectors/modal'
import { selectAreaWritable } from '../../selectors/auth'
import { AREA_CONSTANTS } from '../../services/auth'
import { GroupSettingsPage as Component } from './GroupSettingsPage'

const mapStateToProps = (state: AppStateType) => ({
  group: selectGroup(state),
  activeModal: selectActiveModal(state),
  editable: selectAreaWritable(state, { area: AREA_CONSTANTS.SETTINGS_GROUP }),
})

export const GroupSettingsPage = withRouter(
  connect(mapStateToProps)(Component)
) as React.FC<{}>
